import { View, ViewDensity, ViewType } from "@common/types/views/views";
import { RuleHistoryListColumn } from "./ruleHistoryListViewConfig";

export const defaultTransferRuleHistoryListView: View = {
    type: ViewType.HISTORY_TRANSFER_RULE_LIST,
    columns: [
        { id: RuleHistoryListColumn.TIME },
        { id: RuleHistoryListColumn.RULE_TYPE },
        { id: RuleHistoryListColumn.RULE_GROUP },
        { id: RuleHistoryListColumn.RULE_SUMMARY },
    ],
    filters: {},
    options: {
        selection: true,
        density: ViewDensity.MD,
    },
};
